import PropTypes from 'prop-types';
import React, { Component } from 'react';
import map from 'lodash/map';
import classNames from 'classnames';
import onClickOutside from 'react-onclickoutside';
import BarberOption from './barberOption';
import SelectAllFiltersOption from './selectAllFiltersOption';

class BarbersFilter extends Component {
  constructor(props) {
    super(props);
    this.state = { isActive: false };
  }

  toggleDropdown = (e) => {
    e.preventDefault();
    this.setState({ isActive: !this.state.isActive });
  };

  handleClickOutside = () => {
    if (this.state.isActive) {
      this.setState({ isActive: false });
    }
  };

  isViewed(barber = null) {
    if (barber) {
      return this.props.barbersViewed.some(b => b === barber.id);
    }
    return this.props.barbersViewed.length === this.props.barbers.length;
  }

  render() {
    const {
      toggleDropdown,
      props: { barbers, updateBarbersViewed },
    } = this;

    const filters = map(barbers, (barber, index) => (
      <BarberOption
        key={index}
        barber={barber}
        updateBarbersViewed={updateBarbersViewed}
        checked={this.isViewed(barber)}
        automationIdPart="barbers"
      />
    ));

    const dropdownBodyClass = classNames('c-tooltip c-tooltip--barbers u-p0', {
      'is-active': this.state.isActive,
    });

    const dropdownTriggerClass = classNames('c-dropdown-new', {
      'is-active': this.state.isActive,
    });

    return (
      <div className={classNames('barbers-filter has-tooltip o-flexbox__item', this.props.className)}>
        <a href="" className={dropdownTriggerClass} onClick={toggleDropdown} data-automation-id="filter:barbers">
          Barbers
        </a>
        <div className={dropdownBodyClass}>
          <ul className="c-separator-list barbers-filter__dropdown">
            <li className="c-separator-list__item">
              <SelectAllFiltersOption
                onChange={updateBarbersViewed}
                checked={this.isViewed()}
                automationId="filter:barbers:selectDeselectAll"
              />
              {filters}
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

BarbersFilter.propTypes = {
  updateBarbersViewed: PropTypes.func.isRequired,
  barbersViewed: PropTypes.arrayOf(PropTypes.string),
  barbers: PropTypes.arrayOf(PropTypes.object),
  className: PropTypes.string,
};

BarbersFilter.defaultProps = {
  barbersViewed: [],
  barbers: [],
  className: 'u-ml--',
};

export default onClickOutside(BarbersFilter);
